import b from 'b_';
import cx from 'classnames';
import React, { MouseEventHandler, useRef, ReactChild, ReactNode } from 'react';

import PaletteTooltip from '../__tooltip/palette__tooltip';
import { PALETTE_ORIENTATION } from '../types';
import { getTooltipDirection } from '../utils';

import './palette__button.scss';

interface Props {
    className?: string;
    hovered: boolean;
    popupLabel: ReactChild;
    onMouseEnter: MouseEventHandler;
    onMouseLeave: MouseEventHandler;
    onClick: MouseEventHandler;
    orientation: PALETTE_ORIENTATION;
    children: ReactNode;
}

const PaletteButton = (props: Props) => {
    const { onMouseEnter, onMouseLeave, onClick, children, className, hovered, popupLabel, orientation } = props;
    const targetRef = useRef<HTMLDivElement>(null);

    return (
        <div
            className={cx(b('palette', 'button', { orientation }), className)}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            ref={targetRef}
        >
            {children}
            <PaletteTooltip direction={getTooltipDirection(orientation)} show={hovered} target={targetRef}>
                {popupLabel}
            </PaletteTooltip>
        </div>
    );
};

export default PaletteButton;
